import { CustomerTable } from './CustomerTable';
export default CustomerTable;
